module.exports = __webpack_public_path__ + "img/img.8eea38f6.jpg";